import { render } from "./ExclamationIcon.vue?vue&type=template&id=68089850"
import script from "./ExclamationIcon.vue?vue&type=script&lang=js"
export * from "./ExclamationIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__